import React from 'react';
import { useIntl } from 'react-intl';
import { Alert, Button } from 'reactstrap';
import { TypedMemo } from '../common/types';
import { workspaceMessages } from './workspaceMessages';
import type { WorkspaceSwitchFailure } from './useSwitchWorkspace';

interface WorkspaceSwitchErrorProps {
  failure: WorkspaceSwitchFailure;
  workspaceName: string;
  onRetry: () => void;
}

/**
 * design: workspaces a4. The alert under the workspace rows. "No longer a member" has no retry:
 * the list reloads without the row.
 */
const WorkspaceSwitchErrorComponent: React.FC<WorkspaceSwitchErrorProps> = ({ failure, workspaceName, onRetry }) => {
  const intl = useIntl();
  if (failure.lostMembership) {
    return (
      <Alert color="danger" className="mx-1 my-1 py-2 px-3 small" role="alert">
        {intl.formatMessage(workspaceMessages.noLongerMember, { workspace: workspaceName })}
      </Alert>
    );
  }
  return (
    <Alert color="danger" className="mx-1 my-1 py-2 px-3 small" role="alert">
      {intl.formatMessage(workspaceMessages.switchFailed, { workspace: workspaceName })}{' '}
      <Button color="link" size="sm" className="p-0 align-baseline fw-semibold" onClick={onRetry}>
        {intl.formatMessage(workspaceMessages.tryAgain)}
      </Button>
    </Alert>
  );
};

export const WorkspaceSwitchError = TypedMemo(WorkspaceSwitchErrorComponent);
